var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIngredientManagementSource(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 51,
    viewBox: "0 0 43 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6254 17.082C22.1681 17.082 22.6081 16.6439 22.6081 16.1035C22.6081 15.5631 22.1681 15.125 21.6254 15.125C21.0827 15.125 20.6428 15.5631 20.6428 16.1035C20.6428 16.6439 21.0827 17.082 21.6254 17.082Z",
    fill: "url(#paint0_linear_969_4898)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2403 18.5761C41.8423 18.2087 41.2205 18.232 40.8518 18.6285L34.9291 24.9918H29.7717V18.3464L34.5639 12.3813C34.9213 12.5224 35.3104 12.6008 35.7177 12.6008C37.4504 12.6008 38.8602 11.197 38.8602 9.47158C38.8602 7.74609 37.4504 6.34229 35.7177 6.34229C33.985 6.34229 32.5752 7.74609 32.5752 9.47158C32.5752 10.0798 32.751 10.6476 33.0537 11.1284L28.0219 17.3918C27.8824 17.5653 27.8065 17.7809 27.8065 18.003V24.9917H22.6081V20.4935C22.6081 19.9531 22.1682 19.5149 21.6254 19.5149C21.0827 19.5149 20.6428 19.953 20.6428 20.4935V24.9917H15.3724V10.6188C15.3724 10.0785 14.9324 9.64033 14.3897 9.64033H8.67682V8.46807C8.67682 7.92773 8.23688 7.48955 7.69417 7.48955H3.37443C2.83182 7.48955 2.39178 7.92764 2.39178 8.46807V12.7696C2.39178 13.31 2.83172 13.7481 3.37443 13.7481H7.69427C8.23688 13.7481 8.67692 13.3101 8.67692 12.7696V11.5974H13.4073V24.9918H8.32191L2.39923 18.6285C2.0303 18.2321 1.40864 18.2088 1.01067 18.5761C0.612711 18.9434 0.589077 19.5625 0.958012 19.9588L6.9104 26.354V49.9782C6.9104 50.5186 7.35034 50.9567 7.89305 50.9567H35.358C35.9007 50.9567 36.3407 50.5187 36.3407 49.9782V26.354L42.2931 19.9588C42.662 19.5625 42.6384 18.9434 42.2403 18.5761ZM35.7177 8.29932C36.3668 8.29932 36.895 8.82529 36.895 9.47168C36.895 10.1181 36.3668 10.6439 35.7177 10.6439C35.0685 10.6439 34.5404 10.1181 34.5404 9.47168C34.5404 8.8252 35.0684 8.29932 35.7177 8.29932ZM6.71172 11.7911H4.35708V9.44648H6.71172V11.7911ZM34.3755 48.9998H8.87541V26.9488H34.3755V48.9998Z",
    fill: "url(#paint1_linear_969_4898)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6428 7.05801V11.7039C20.6428 12.2442 21.0827 12.6824 21.6254 12.6824C22.1681 12.6824 22.6081 12.2443 22.6081 11.7039V7.05801C23.8609 6.64619 24.768 5.47002 24.768 4.08633C24.768 2.36084 23.3582 0.957031 21.6254 0.957031C19.8927 0.957031 18.4829 2.36084 18.4829 4.08633C18.4829 5.47012 19.3899 6.64619 20.6428 7.05801ZM21.6254 2.91397C22.2745 2.91397 22.8027 3.43994 22.8027 4.08633C22.8027 4.73272 22.2745 5.25859 21.6254 5.25859C20.9763 5.25859 20.4481 4.73272 20.4481 4.08633C20.4481 3.43994 20.9763 2.91397 21.6254 2.91397Z",
    fill: "url(#paint2_linear_969_4898)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6161 41.8979C26.8102 42.1371 27.0943 42.2614 27.3808 42.2613C27.5976 42.2613 27.816 42.1902 27.9979 42.0438L32.1087 38.7357C32.3396 38.55 32.4737 38.2703 32.4737 37.9747C32.4737 37.6791 32.3396 37.3995 32.1087 37.2137L27.9979 33.9055C27.5763 33.5658 26.9572 33.6312 26.6161 34.0515C26.275 34.4717 26.3406 35.0879 26.7627 35.4274L29.9278 37.9746L26.7627 40.5217C26.3406 40.8615 26.275 41.4776 26.6161 41.8979Z",
    fill: "url(#paint3_linear_969_4898)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1422 38.7361L15.253 42.0442C15.4348 42.1906 15.653 42.2617 15.8701 42.2617C16.1566 42.2617 16.4407 42.1374 16.6348 41.8982C16.9759 41.478 16.9103 40.8618 16.4882 40.5222L13.3231 37.9751L16.4882 35.428C16.9103 35.0884 16.976 34.4722 16.6348 34.052C16.2938 33.6317 15.6749 33.5663 15.253 33.906L11.1422 37.2142C10.9113 37.3999 10.7771 37.6796 10.7771 37.9752C10.7771 38.2708 10.9113 38.5502 11.1422 38.7361Z",
    fill: "url(#paint4_linear_969_4898)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3182 41.5289C19.476 41.6226 19.6494 41.6673 19.8206 41.6673C20.1553 41.6673 20.4815 41.4969 20.6654 41.1899L24.2732 35.168C24.5512 34.704 24.3988 34.1033 23.9327 33.8264C23.4667 33.5494 22.8636 33.7013 22.5855 34.1654L18.9776 40.1874C18.6997 40.6514 18.8521 41.252 19.3182 41.5289Z",
    fill: "url(#paint5_linear_969_4898)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_969_4898",
    x1: 21.6254,
    y1: 15.125,
    x2: 21.6254,
    y2: 17.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_969_4898",
    x1: 21.6255,
    y1: 6.34229,
    x2: 21.6255,
    y2: 50.9567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_969_4898",
    x1: 21.6254,
    y1: 0.957031,
    x2: 21.6254,
    y2: 12.6824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_969_4898",
    x1: 29.4357,
    y1: 33.688,
    x2: 29.4357,
    y2: 42.2613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_969_4898",
    x1: 13.8152,
    y1: 33.6885,
    x2: 13.8152,
    y2: 42.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_969_4898",
    x1: 21.6254,
    y1: 33.688,
    x2: 21.6254,
    y2: 41.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredientManagementSource);
export default __webpack_public_path__ + "static/media/Ingredient_Management_source.67a5be64f50dd1aa6cb760a76a9316c9.svg";
export { ForwardRef as ReactComponent };